import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import { resetChat } from '../../actions';
import { getConsultationSummary } from '../../services';

const ChatRedirector = () => {
  const location = useLocation();
  const history = useHistory();
  const { authToken, userId } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const params = new URLSearchParams(location.search);
  console.log(params.get('cid'));
  if (params.get('cid')) {
    dispatch(resetChat());
    getConsultationSummary(params.get('cid'), userId, authToken)
      .then((res) => {
        const { consultationInfo } = res;
        history.push('/consultation/upload-documents', {
          consultationId: consultationInfo.consultationId,
          channel: consultationInfo.chatChannel,
          doctorName: consultationInfo.doctorName,
          doctorVertical: consultationInfo.doctorDegrees,
          doctorId: consultationInfo.doctorId,
          pendingRequest: consultationInfo.isOver === false,
          requestId: consultationInfo.requestId,
          profileImg: consultationInfo.doctorImg,
          isFreeConsult: consultationInfo.freeConsult,
          activeContact: res.activeContact,
          userSkippedEmergencyContact: res.userSkippedEmergencyContact,
          isOver: consultationInfo.isOver,
          isCancelled: consultationInfo.isCancelled,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }
  return <div></div>;
};

export default ChatRedirector;
